import { Route, Routes } from 'react-router-dom';
import MaintainerAuthBaseScreen from './screens/MaintainerAuthBaseScreen';

MaintainerAuth.propTypes = {};

function MaintainerAuth(props) {
  return (
    <Routes>
      <Route path="*" element={<MaintainerAuthBaseScreen />} />
    </Routes>
  );
}

export default MaintainerAuth;
